import deepFreeze from "deep-freeze-es6";

export function addETag<T extends object>(obj: T, etag: string): Readonly<WithETag<T>> {
  return deepFreeze({ ...obj, etag });
}

export type WithETag<T extends object> = Readonly<T & { etag: string }>;
